module.exports = __webpack_public_path__ + "assets/img/bottom.d88f6e9f.png";